/**
 * Utility functions to convert HTML content to PowerPoint-compatible format
 */

/**
 * Converts HTML to plain text, preserving basic formatting hints
 */
export function htmlToText(html: string): string {
  if (!html) return '';
  
  // Remove script and style tags
  let text = html.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '');
  text = text.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
  
  // Convert common HTML tags to text equivalents
  text = text.replace(/<br\s*\/?>/gi, '\n');
  text = text.replace(/<\/p>/gi, '\n\n');
  text = text.replace(/<\/div>/gi, '\n');
  text = text.replace(/<\/h[1-6]>/gi, '\n\n');
  text = text.replace(/<\/li>/gi, '\n');
  
  // Remove HTML tags
  text = text.replace(/<[^>]+>/g, '');
  
  // Decode HTML entities
  text = text.replace(/&nbsp;/g, ' ');
  text = text.replace(/&amp;/g, '&');
  text = text.replace(/&lt;/g, '<');
  text = text.replace(/&gt;/g, '>');
  text = text.replace(/&quot;/g, '"');
  text = text.replace(/&#39;/g, "'");
  text = text.replace(/&apos;/g, "'");
  
  // Clean up whitespace
  text = text.replace(/\n\s*\n\s*\n/g, '\n\n');
  text = text.trim();
  
  return text;
}

/**
 * Extracts LaTeX expressions from HTML/text content
 * Returns array of LaTeX expressions found
 */
export function extractLaTeXExpressions(content: string): string[] {
  const expressions: string[] = [];
  
  // Match inline math: $...$
  const inlineMatches = content.match(/\$([^$]+)\$/g);
  if (inlineMatches) {
    inlineMatches.forEach(match => {
      const expr = match.replace(/\$/g, '');
      if (expr && !expressions.includes(expr)) {
        expressions.push(expr);
      }
    });
  }
  
  // Match block math: $$...$$
  const blockMatches = content.match(/\$\$([^$]+)\$\$/g);
  if (blockMatches) {
    blockMatches.forEach(match => {
      const expr = match.replace(/\$/g, '');
      if (expr && !expressions.includes(expr)) {
        expressions.push(expr);
      }
    });
  }
  
  return expressions;
}

/**
 * Removes LaTeX expressions from content, replacing with placeholders
 */
export function removeLaTeXFromText(content: string): string {
  // Replace block math with placeholder
  let text = content.replace(/\$\$[^$]+\$\$/g, '[FORMULE MATHÉMATIQUE]');
  
  // Replace inline math with placeholder
  text = text.replace(/\$[^$]+\$/g, '[FORMULE MATHÉMATIQUE]');
  
  return text;
}

/**
 * Splits content into paragraphs, handling HTML and LaTeX
 */
export function splitIntoParagraphs(content: string): string[] {
  const text = htmlToText(content);
  const paragraphs = text.split(/\n\s*\n/).filter(p => p.trim().length > 0);
  return paragraphs;
}
